"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const immutable_1 = require("immutable");
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const BarChart_1 = __importDefault(require("@mui/icons-material/BarChart"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const QAmountField_1 = __importDefault(require("components/QAmountField"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const CategoryReviewPopupCard_1 = __importDefault(require("components/CategoryReviewPopupCard"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const editBudgetHelpers_1 = require("components/Budgets/EditBudgetsDialog/editBudgetHelpers");
const categoryGroupsSelectors_1 = require("companion-app-components/flux/category-groups/categoryGroupsSelectors");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const BudgetGroupItem = ({ item, autoFocus, onChange, onDelete, currency, accountIds, isRollup, chartIds, isEverythingElse, overrideLabel, depth = 0, classesPassed }) => {
    const chartIdsToUse = (0, react_1.useMemo)(() => chartIds || (item.coa ? [item.coa.id] : []), [chartIds, item.coa]);
    const [amountFieldValue, setAmountFieldValue] = (0, react_1.useState)(Number(item.amount));
    const [isIncomeItem, setIsIncomeItem] = (0, react_1.useState)(item.isIncome);
    const [catReviewAnchorEl, setCatReviewAnchorEl] = (0, react_1.useState)(null);
    const [showIcons, setShowIcons] = (0, react_1.useState)(false);
    const [alternativeChartIds, setAlternativeChartIds] = (0, react_1.useState)(chartIdsToUse.map((x) => x.id));
    const { classes } = useStyles({ isRollup, depth });
    const categoryGroupsById = (0, react_redux_1.useSelector)((state) => (0, categoryGroupsSelectors_1.getCategoryGroupsById)(state), react_redux_1.shallowEqual);
    (0, react_1.useEffect)(() => {
        // by keeping internal state of the 'value', this prevents from sending multiple change events
        // after changes and before the item is actually changed by the caller
        setAmountFieldValue(Number(item.amount));
        setIsIncomeItem(item.isIncome);
    }, [item]);
    // Determine the id's to use for the chart
    (0, react_1.useEffect)(() => {
        if (!chartIds && item.type === 'GROUP' && item.groupId && categoryGroupsById) {
            const group = categoryGroupsById.get(item.groupId);
            if (group && group.coas) {
                const idList = (0, immutable_1.List)(group.coas.map((coa) => coa.id));
                setAlternativeChartIds(idList);
            }
        }
        else {
            setAlternativeChartIds(chartIdsToUse.map((x) => x.id));
        }
    }, [item, categoryGroupsById, chartIds, chartIdsToUse]);
    const internalOnChange = (e) => {
        // flip the sign for expense cats as appropriate
        const newVal = isIncomeItem ? Number(Math.abs(e.target.value)) : -Number(Math.abs(e.target.value));
        // only indicate change if it, well... changed.
        if (newVal !== Number(amountFieldValue)) {
            const newItem = item.set('amount', newVal);
            if (onChange)
                onChange(newItem);
        }
        setAmountFieldValue(newVal);
    };
    const constructName = () => {
        let str = item.name;
        const catParts = str.split(':');
        let parentStr = '';
        if (!isRollup && catParts.length > (depth + 1)) {
            parentStr = `(${catParts[depth]})`;
        }
        str = catParts[catParts.length - 1];
        if (item.budgetedWithChild)
            str = `Total of ${str}`;
        if (item.type === 'CATEGORY_OTHER')
            str = `${str} (Other)`;
        if (isEverythingElse)
            str = `All others in ${str}`;
        return [str, parentStr];
    };
    const nameArray = overrideLabel ? [overrideLabel, ''] : constructName();
    return (<div className={(0, classnames_1.default)((classesPassed === null || classesPassed === void 0 ? void 0 : classesPassed.categoryRow) || classes.categoryRow, isRollup ? 'rollup' : '')} onMouseEnter={() => setShowIcons(true)} onMouseLeave={() => setShowIcons(false)}>
      <div className={classes.categoryNameWrapper}>
        <Typography_1.default key={`editBudgetCats:str1 ${item.id}`} variant="body2" className={(0, classnames_1.default)(classesPassed === null || classesPassed === void 0 ? void 0 : classesPassed.categoryName, classes.categoryName)}>
          {nameArray[0]}
        </Typography_1.default>
        <Typography_1.default key={`editBudgetCats:str2 ${item.id}`} variant="body2" className={classes.categoryNameParent}>
          {nameArray[1]}
        </Typography_1.default>
      </div>
      <div className={!isRollup ? classes.categoryAmount : classes.rollUpAmount}>
        <QAmountField_1.default id={`budgetAmt:${nameArray[0]}`} editable={!isRollup} expectedSign={item.isIncome ? 'positive' : 'negative'} value={item.isIncome ? Math.abs(amountFieldValue) : -Math.abs(amountFieldValue)} currency={currency} autoFocus={autoFocus} onSubmit={(e) => internalOnChange(e)} submitOnBlur decimals={0} disableUnderline InputProps={{
            classes: {
                input: classes.amountInputStyle,
                adornedStart: classes.dollarAdornment,
            },
        }}/>
      </div>
      {!isRollup &&
            <div className={(0, classnames_1.default)(classes.iconHolder, showIcons ? '' : classes.hide)}>
          <QTip_1.default title="Category Details Card...">
            <QIconButton_1.default aria-label="Show Budget Item Info" onClick={(e) => setCatReviewAnchorEl(e.currentTarget)} id={`row-${item.id}-delete-item`} size="small">
              <BarChart_1.default className={classes.barChartIcon}/>
            </QIconButton_1.default>
          </QTip_1.default>
          {onDelete &&
                    <QIconButton_1.default aria-label="Remove Budget Item" onClick={() => onDelete(item)} id={`row-${item.id}-delete-item`} size="small">
              <Delete_1.default className={classes.deleteIcon}/>
            </QIconButton_1.default>}
          {catReviewAnchorEl &&
                    <CategoryReviewPopupCard_1.default anchorEl={catReviewAnchorEl} open onClose={() => setCatReviewAnchorEl(null)} coa={item.coa} coaIds={alternativeChartIds.toArray()} classes={{
                            root: classes.categoryReviewCardRoot,
                        }} currency={currency} accountIds={accountIds} onSetValueFromGraph={(amt) => internalOnChange({ target: { value: (0, editBudgetHelpers_1.setAmountSign)(amt, item.coa) } })} showCents/>}
        </div>}
    </div>);
};
exports.default = BudgetGroupItem;
